import React, { useState } from 'react';

import { ErrorMessage } from '@hookform/error-message';
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import {apollo_useStyles} from "./Apollo_styles";

interface passinerface {
    register : any ;
    errors   : any ;
    id       : string ;
    name     : string ;
    label    : string ;
}

export const ApolloPassword : React.FC<passinerface> = (props) => {

    const classes = apollo_useStyles();
    const [showpassword, setShowPass] = React.useState(false);

    const handleChange = (prop: any ) => (event: React.ChangeEvent<HTMLInputElement>) => {
        if( event.target.value === props.id ) {
            setShowPass( !showpassword );
        }
    };

    const handleClickShowPassword = () => {
        setShowPass(!showpassword);
    };

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    return (<div>
        <FormControl className={classes.form} variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">{props.label}</InputLabel>
            <OutlinedInput
                id={props.id}
                type={ showpassword ? 'text' : 'password'}
                onChange={ handleChange( props.id )}
                required
                fullWidth
                name= { props.name}
                label= {props.label}
                inputRef={ props.register({
                    required: 'パスワードは必ず入力してください。',
                    minLength: { value: 8, message: 'パスワードは8文字以上入力してください。' },
                    maxLength: { value: 24, message: 'パスワードは24文字以内で入力してください。' }
                })}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                        >
                            { showpassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </InputAdornment>
                }
            />
        </FormControl>
        <ErrorMessage errors={ props.errors } name={props.name} />
    </div>)
}